import React from "react";
import { Box } from "@mui/material";
import PageHeader from "../../../../../../../components/PageHeader";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";
import { POPageContextProvider } from "./POPageContext";
import PoMangerMain from "./Main";

export default function POPage() {
  const { plant } = useRoutePlant();

  return (
    <POPageContextProvider>
      <Box>
        <PageHeader plant={plant} pageTitle="Purchase Order (PO)" />
        <PoMangerMain />
      </Box>
    </POPageContextProvider>
  );
}
